export enum GlobalColors {
  // Hue Black - 1XX
  Black = 101,
  // Hue Brown - 2XX
  Carnation = 201,
  Brown = 202,
  Sepia = 203,
  Sandal = 204,
  WoodyBrown = 205,
  // Hue Red - 3XX
  Red = 301,
  Chablis = 302,
  Alizarin = 303,
  Cinnabar = 304,
  Roman = 305,
  Thunderbird = 306,
  Charm = 307,
  Rust = 308,
  Cardinal = 309,
  Blush = 310,
  Lotus = 311,
  TiaMaria = 312,
  FireBrick = 313,
  Amaranth = 314,
  Valencia = 315,
  Jazz = 316,
  Melon = 317,
  Geraldine = 318,
  // Hue Orange - 4XX
  Sunglow = 401,
  Flamenco = 402,
  Salmon = 403,
  // Hue Yellow - 5XX
  MilkPunch = 501,
  Tan = 502,
  Buttercup = 503,
  Mustard = 504,
  Desert = 505,
  Picasso = 506,
  Meteor = 507,
  Galliano = 508,
  Tussock = 509,
  // Hue Green - 6XX
  GreenPea = 601,
  Laurel = 602,
  ElfGreen = 603,
  Lake = 604,
  DeYork = 605,
  FruitSalad = 606,
  Shadow = 607,
  Bilbao = 607,
  Mantis = 608,
  Swamp = 609,
  ChaletGreen = 610,
  Asparagus = 611,
  SeaNymph = 612,
  Plantation = 613,
  Salem = 614,
  ChateauGreen = 615,
  MountainMeadow = 616,
  // Hue Blue - 7XX
  Denim = 701,
  Mariner = 702,
  AliceBlue = 703,
  Pelorous = 704,
  Zircon = 705,
  PictonBlue = 706,
  SteelBlue = 707,
  Danube = 708,
  Malibu = 709,
  SummerSky = 710,
  Calypso = 711,
  FunBlue = 712,
  Cerulean = 713,
  Manatee = 714,
  ShipCove = 715,
  CloudBurst = 716,
  Chambray = 717,
  Biscay = 718,
  Matisse = 719,
  CuriousBlue = 720,
  PortGore = 721,
  MulledWine = 722,
  RoyalBlue = 723,
  // Hue Violet - 8XX
  Fuchsia = 801,
  MediumPurple = 802,
  BlueViolet = 803,
  Plum = 804,
  Amethyst = 805,
  MoodyBlue = 806,
  PurpleHeart = 807,
  Revolver = 808,
  ElectricViolet = 809,
  Jagger = 810,
  Voodoo = 811,
  Orchid = 812,
  Perfume = 813,
  Lavender = 814,
  // Hue Grey - 9XX
  Gainsboro = 901,
  Antimony = 902,
  Silver = 903,
  Concrete = 904,
  Nobel = 905,
  SilverChalice = 906,
  DustyGrey = 907,
  Seal = 908,
  Boulder = 909,
  DoveGrey = 910,
  DimGrey = 911,
  Gravel = 912,
  Zambezi = 913,
  Mortar = 914,
  BattleshipGrey = 915,
  Emperor = 916,
  Charcoal = 917,
  Eclipse = 918,
  NightRider = 919,
  MineShaft = 920,
  Nero = 921,
  CodGrey = 922,
  Tuna = 923,
  // Hue White - 10XX
  White = 1001,
  Cream = 1002,
  FloralWhite = 1003,
  Snow = 1004,
  Honeydew = 1005,
  Alabaster = 1006,
  WildSand = 1007,
  WhiteSmoke = 1008,
  Mercury = 1009,
  Alto = 1010,
  Moon = 1011,
  Zinc = 1012,
  Gallery = 1013,
  Cadmium = 1014,
};